import * as React from 'react';
import { StyleSheet, View } from 'react-native';
import { inject, observer } from 'mobx-react';
import styled from 'styled-components';
import { ClipLoader } from 'react-spinners';

import colors from '../../constants/colors';
import { TextNormal } from './Typography';
import { UIStoreType } from '../../stores/ui';
import ToolTip from './ToolTip';
import { margins } from '../../constants/metrics';

const Input = styled.textarea`
  border-radius: 4px;
  min-height: 35px;
  font-size: 18px;
  caret-color: ${colors.secondary};
  border-radius: 10px;
  border-width: 2px;
  border-style: solid;
  border-color: ${colors.borders};
  color: ${colors.black};
  padding-left: 10px;
  ::placeholder {
    color: ${colors.lightGray};
  }
  &:focus {
    outline: none;
    border-bottom-color: ${colors.primary};
    border-bottom-width: 2px;
  }
  ${({ inputStyle }: any) => inputStyle};
  resize: none;
`;

interface P {
  style?: any;
  ui?: UIStoreType;
  label?: string;
  error?: string;
  onChange?: any;
  value?: any;
  type?: string;
  placeholder?: string;
  onChangeText?: (str: string) => void;
  maxLength?: string;
  min?: number;
  max?: number;
  inputStyle?: any;
  lightLabel?: string;
  disabled?: boolean;
  onFocus?: () => void;
  onBlur?: () => void;
  getRef?: (ref: any) => void;
  getTextInputRef?: (ref: any) => void;
  loading?: boolean;
  toolTip?: string;
}

interface S {
  isFocused: boolean;
}

@inject('ui')
@observer
class FittTextArea extends React.Component<P, S> {
  state = {
    isFocused: false,
  };

  _onFocus = () => {
    this.setState({ isFocused: true }, () => {
      if (this.props.onFocus) {
        this.props.onFocus();
      }
    });
  };

  _onBlur = () => {
    this.setState({ isFocused: false }, () => {
      if (this.props.onBlur) {
        this.props.onBlur();
      }
    });
  };

  render() {
    const { isMobile } = this.props.ui!;

    let inputStyle = {
      width: isMobile ? 180 : undefined,
      minWidth: isMobile ? undefined : 207,
    };

    if (this.props.inputStyle) {
      inputStyle = {
        ...inputStyle,
        ...this.props.inputStyle,
      };
    }

    return (
      <View
        style={[styles.main, this.props.style]}
        ref={(ref: any) => {
          if (this.props.getRef) {
            this.props.getRef(ref);
          }
        }}
      >
        {this.props.label && (
          <div style={{ marginBottom: margins[4] }}>
            <TextNormal style={{ marginRight: margins[3] }}>
              {this.props.label}
            </TextNormal>
            {this.props.toolTip && (
              <ToolTip style={{ marginTop: 5 }} text={this.props.toolTip} />
            )}
          </div>
        )}
        <View style={styles.row}>
          <Input
            ref={(ref: any) => {
              if (this.props.getTextInputRef) {
                this.props.getTextInputRef(ref);
              }
            }}
            // maxLength={this.props.maxLength}
            onFocus={this._onFocus}
            onBlur={this._onBlur}
            disabled={this.props.disabled}
            value={this.props.value}
            onChange={(e: any) => {
              if (this.props.onChange) {
                this.props.onChange(e);
              }
              if (this.props.onChangeText) {
                if (
                  this.props.type === 'price' ||
                  this.props.type === 'number'
                ) {
                  const re = /^[0-9\b]+$/;
                  if (e.target.value === '' || re.test(e.target.value)) {
                    this.props.onChangeText(e.target.value);
                  }
                } else {
                  this.props.onChangeText(e.target.value);
                }
              }
            }}
            placeholder={this.props.placeholder}
            // @ts-ignore
            inputStyle={[
              inputStyle,
              this.props.disabled
                ? { backgroundColor: 'rgb(230,230,230)' }
                : {},
            ]}
          />
        </View>

        {this.props.error && this.props.error.length ? (
          <TextNormal
            style={{
              color: colors.error,
              marginTop: 5,
            }}
          >
            {this.props.error}
          </TextNormal>
        ) : null}
        {this.props.loading ? (
          <View
            style={{
              width: 25,
              justifyContent: 'center',
              alignItems: 'center',
              backgroundColor: 'transparent',
              position: 'absolute',
              right: 15,
              top: 3,
              bottom: 3,
            }}
          >
            <ClipLoader
              size={16}
              color={colors.black}
              loading={this.props.loading}
            />
          </View>
        ) : null}
      </View>
    );
  }
}

const styles = StyleSheet.create({
  main: {},
  row: {
    flexDirection: 'row',
    alignItems: 'center',
  },
});

export default FittTextArea;
